import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SRLZ（グルメ放浪詩人） */
const srlzContent: DiagnosisResultContent = {
  code: 'SRLZ',
  name: 'グルメ放浪詩人',
  catchphrase: '美味しい匂いに導かれて生きる。胃袋のアンテナで絶品と出会う',
  rarity: 4,
  style:
    '「あてもなく歩き、出会った味に浸る」風流な放浪派。計画は持たず、のんびり街をさまよいながら、心惹かれた店にふらりと入る。冒険的なグルメを楽しみつつ、急がず余韻まで味わう。効率や網羅とは無縁で、偶然の一皿との出会いを詩のように慈しむ。食と情緒を愛でる、旅の吟遊詩人タイプ。',
  strengths: [
    { lead: '偶然を味方にできる', text: 'あてのない散策から、忘れがたい一軒を引き当てる。' },
    { lead: '余韻を楽しめる', text: '急がないため、味も雰囲気も心にじっくり染み込む。' },
    { lead: '感性が豊か', text: '食を通じて土地の情緒まで味わい、旅に深みが出る。' },
  ],
  weaknesses: [
    { lead: '効率は度外視', text: '気の向くままゆえ、見たい所・食べたい物を逃すことも。' },
    { lead: '予約が苦手', text: '計画しないため、人気店には縁がないことが多い。' },
    { lead: 'ペースが独特', text: 'マイペースな放浪に、同行者がついていけないことがある。' },
  ],
  aaru: [
    { icon: 'utensils', text: '路地裏の一軒にふらり' },
    { icon: 'coffee', text: '食後の余韻を散歩で味わう' },
    { icon: 'msg', text: '「この匂い、いいなあ」が口癖' },
    { icon: 'camera', text: '料理より店の佇まいを撮る' },
  ],
  manual: {
    good: 'あてのない散策に付き合う／余韻を急かさない',
    ng: '「次どこ行く？」と効率を求める',
    tips: '集合場所と時間だけ決めれば自由に放浪できる',
  },
  compatibility: {
    good: 'SRCZ（マイペース）／PALZ（のんびり食）',
    conflict: 'PACE（完璧弾丸）／SALE（爆速即興）',
    tips: '半日は別行動にすると互いに心地よい',
  },
  destinations: {
    domestic: '尾道（路地と食の情緒）／金沢（趣ある町並みと味）',
    overseas: 'リスボン（坂道と食の散策）／ハノイ（路地裏グルメ）',
  },
};

export const srlzDiagnosisResult = buildDiagnosisResult(srlzContent);
